module.exports = __webpack_public_path__ + "img/japan-digestive-diseases-female.5471fc3c.png";